import { useApolloClient } from "@apollo/client";
import Cookies from "js-cookie";
import { includes } from "lodash";
import { useNavigate, useSearchParams } from "react-router";
import axios from "@/shared/services/api/rest";
import { workspaceRoutes } from "@/features/workspace/services/routes";

export const handleForceLogout = async () => {
  await axios.post(workspaceRoutes.logout, {}, { withCredentials: true });
  localStorage.removeItem("token");

  Cookies.remove("sid");
  Cookies.remove("_s");

  if (
    window.location.pathname !== "/login" &&
    !includes(window.location.pathname, "/invite")
  ) {
    window.location.replace(`/login?redirect=${window.location.pathname}`);
  }
};

export const useLogout = (redirect?: boolean) => {
  const navigate = useNavigate();
  const apollo = useApolloClient();
  const [searchParams] = useSearchParams();
  const handleLogout = async () => {
    await axios.post(workspaceRoutes.logout, {}, { withCredentials: true });
    localStorage.removeItem("token");
    window.localStorage.removeItem("recentOrg");
    apollo.resetStore();
    navigate(
      `/login${redirect ? `?redirect=${window.location.pathname}` : ""}`,
      { replace: true }
    );
  };

  return { handleLogout };
};
